import styled from 'styled-components'
const Wrapper = styled.div`
.thead{
    height: 73px;
    justify-content: space-between;
    align-items: center;
    align-self: stretch;
    }   
    .thead tr th{
        background: #D8EDFF;
        color: #4B5563;
        font-size: 14px;
        font-style: normal;
        font-weight: 600;
        line-height: normal;
        text-align : center;
    } 
        tbody tr td{

        text-align : center;
    } 

    .left-radius{
        border-radius: 12px 0px 0 0;
        background: #D8EDFF;
    }
    .right-radius {
        border-radius: 0px 12px 0 0;
        background: #D8EDFF;
    }
    .no-radius{
        background: #D8EDFF;
    }

    .edit-minutes{
        color: #2196F3;
        font-size: 1.1rem;
    }
    .edit-minutes:hover {
    transform: scale(1.2);
    }
 `
  export default Wrapper